import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appMuNotImagen]',
})
export class MuNotImagenDirective {
  @Input() appMuNotImagen: string;
  @Input() applyStyles: string;

  constructor(private elementRef: ElementRef, private renderer2: Renderer2) {
    /** */
  }

  @HostListener('error') loadDefaultImage() {
    const element = this.elementRef.nativeElement;
    if (this.applyStyles && this.applyStyles === 'true') {
      this.renderer2.addClass(element, 'mu-not-img');
    }
    element.src = this.appMuNotImagen || 'assets/images/icons/user-gray.svg';
  }
}
